import { api } from '../assets/config/api.config';

export const environment = {
  production: true,
  version: '3305',
  apiUrl: api.prod,
  name: 'production',
  sentryDsn: 'https://9e61b937d01447168c34bc5ebac3b490@o1295285.ingest.sentry.io/6520598',
  isLocal: false
};
